<ng-container *ngIf="instance">
    <!-- <div style="overflow: auto"> -->
    <mat-chip-grid #chips class="tt-search-multi-select__mat-chip-grid">
        <mat-chip-row *ngFor="let id of instance.selectedNames" class="tt-search-multi-select__mat-chip-row" (removed)="instance.remove(id, auto)">
            {{ id }}
            <button matChipRemove class="tt-search-multi-select__remove" [attr.aria-label]="'remove ' + id">
                <span class="far fa-times"></span>
            </button>
        </mat-chip-row>
    </mat-chip-grid>
    <!-- </div> -->
    <div ref="eWrapper" class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper" role="presentation">
        <input
            class="ag-input-field-input ag-text-field-input tt-chip-floating-filter-tooltip-input"
            #inputRef
            #chipInput="matChipInput"
            [placeholder]="selectedNamesTooltip"
            [formControl]="instance.searchControl"
            [matChipInputFor]="chips"
            [matAutocomplete]="auto"
        />
        <!-- (optionSelected)="selected($event)" -->
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="instance.selected($event)" hideSingleSelectionIndicator autoActiveFirstOption multiple class="ag-custom-component-popup">
            <mat-option *ngFor="let item of instance.data | async" [id]="item" class="tt-listbox__item ag-custom-component-popup" [value]="item">
                <span>{{ item }}</span>
            </mat-option>
        </mat-autocomplete>
    </div>
</ng-container>
